<template>
  <h1 class="text-center py-3">
    {{ title ||  $t('spinner.title') }}
    <br />
    <br />
    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    <br />
    <br />
    <span class="text-secondary" v-html="description || $t('spinner.description')" />
  </h1>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    description: String
  },
  methods: {
  },
  computed: {
  }
};
</script>

<style scoped>
</style>
